export class CancelMyMPARequestResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mpaRequest",
            "baseName": "mpaRequest",
            "type": "MPARequest",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CancelMyMPARequestResponse.attributeTypeMap;
    }
    constructor() {
    }
}
